import React from 'react';


const WorkflowComponent = () => {
  return (
    <div className="workflow-container">
      <h2 className="workflow-title">Procedimiento de solicitud</h2>
      <div className="workflow-item">
        <h2 className="workflow-step-title">1. Aceptación del artículo</h2>
        <p className="workflow-text">La solicitud de financiación se pedirá una vez que la revista haya aceptado nuestro artículo para su publicación.</p>
      </div>
      <div className="workflow-item">
        <h2 className="workflow-step-title">2. Correo electrónico del editor</h2>
        <p className="workflow-text">Cuando la revista haya aceptado nuestro artículo, el editor nos enviará un correo con un enlace para iniciar el <span className="cursiva">author journey</span>.</p>
      </div>
      <div className="workflow-item">
        <h2 className="workflow-step-title">3. Filiación Universidad de Oviedo</h2>
        <p className="workflow-text">Dentro de la plataforma de gestión del autor o la autora, lo más importante es elegir como filiación la Universidad de Oviedo; de lo contrario el editor no podrá enviar la solicitud de financiación para aplicar el acuerdo transformativo.</p>
      </div>
      <div className="workflow-item">
        <h2 className="workflow-step-title">4. Publish Open Access</h2>
        <p className="workflow-text">De todas las opciones para publicar, elegiremos la opción de publicarlo en acceso abierto.</p>
      </div>
      <div className="workflow-item">
        <h2 className="workflow-step-title">5. Licencia Creative Commons</h2>
        <p className="workflow-text">Al elegir la opción anterior tendremos que seleccionar una licencia creative commons para proteger nuestros derechos de propiedad intelectual. Hay dos opciones: que podamos definir los usos permitidos según nuestras preferencias o que estemos obligados a seleccionar la única que permita el editor.</p>
      </div>
      <div className="workflow-item">
        <h2 className="workflow-step-title">6. Aprobación BUO</h2>
        <p className="workflow-text">Cuando el autor o la autora elija como filiación la Universidad de Oviedo y la opción de acceso abierto el editor comprobará si existe acuerdo transformativo con su institución y si lo hay enviará a la Universidad la solicitud de financiación. La Biblioteca Universitaria es la que se encarga de aprobar las solicitudes.</p>
      </div>
      <div className="workflow-item">
        <h2 className="workflow-step-title">7. Notificación automática</h2>
        <p className="workflow-text">Una vez que la BUO aprueba una solicitud a través de los diferentes <span className="cursiva">dashboards</span> de los editores, estos envían un correo electrónico automático al autor o a la autora informando de que su institución ha aprobado la solicitud.</p>
      </div>
      <p className="workflow-summary">Recibida dicha notificación el autor o la autora ya no tiene que hacer nada más, salvo que estemos ante un descuento del total de los APCs, en cuyo caso recibirá una factura ya con el descuento aplicado que tendrá que pagar con fondos propios.</p>
      <p className="workflow-summary">
        Consulta en detalle el procedimiento o workflow de cada editor en la guía de la  
        <a href="https://biblioguias.unav.edu/acuerdos-transformativos/procedimiento-investigadores-un" 
           target="_blank" 
           rel="noopener noreferrer" 
           className="workflow-link"> Universidad de Navarra</a>.
      </p>
    </div>
    
  );
};

export default WorkflowComponent;
